import script from "./RfidProcessingLogsPage.vue?vue&type=script&setup=true&lang=js"
export * from "./RfidProcessingLogsPage.vue?vue&type=script&setup=true&lang=js"

import "./RfidProcessingLogsPage.vue?vue&type=style&index=0&id=3b2d20bb&scoped=true&lang=css"

import exportComponent from "/home/marco/docker-devs/laundryrepublic/codebase/lr-epos2-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3b2d20bb"]])

export default __exports__